import { render } from "./BaseDisabledInput.vue?vue&type=template&id=2b48afdc&scoped=true"
import script from "./BaseDisabledInput.vue?vue&type=script&lang=js"
export * from "./BaseDisabledInput.vue?vue&type=script&lang=js"

import "./BaseDisabledInput.vue?vue&type=style&index=0&id=2b48afdc&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b48afdc"]])

export default __exports__